import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { Observable } from 'rxjs';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { EShopState } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { IConfigurationService, IConfigurationServiceToken } from 'projects/shared/lib/services/infrastructure/configuration/configuration-service.interface';
import { ISidebarCartService, ISidebarCartServiceToken } from 'shared/services/ui/sidebar/cart/sidebar-cart-service.interface';

@Injectable({
  providedIn: 'root'
})
export class CartPreviewInterceptorGuard {

  private cartPreviewVisibleRoutes: string[] | undefined;
  private cartPreviewHiddenRoutes: string[] | undefined;
  private readonly sidebarCartService: ISidebarCartService = inject(ISidebarCartServiceToken);
  private readonly configuration: IConfigurationService;

  public constructor() {
    this.cartPreviewVisibleRoutes = ENVIRONMENT.cart.cartPreview.cartPreviewVisibleRoutes;
    this.cartPreviewHiddenRoutes = ENVIRONMENT.cart.cartPreview.cartPreviewHiddenRoutes;

    this.configuration = ServiceLocator.injector.get(IConfigurationServiceToken);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    let shopState = this.configuration.shopStateGetOrUndefined();

    if (shopState == EShopState.Maintenance || shopState == EShopState.Offline) {
      this.sidebarCartService.sidebarShoppingCartHide();
      return true;
    }

    let targetUrl = state?.url;

    let shouldHideSidebarShoppingCart = this.isCartPreviewHiddenOnTargetRoute(targetUrl);
    if (shouldHideSidebarShoppingCart) {
      this.sidebarCartService.sidebarShoppingCartHide();
      return true;
    }

    let shouldShowSidebarShoppingCart = this.isCartPreviewVisibleTargetRoute(targetUrl);
    if (shouldShowSidebarShoppingCart) {
      this.sidebarCartService.sidebarShoppingCartShow();
      return true;
    }

    return true;
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  public canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let targetUrl = nextState?.url;

    if (this.isCartPreviewHiddenOnTargetRoute(targetUrl)) {
      this.sidebarCartService.sidebarShoppingCartHide();
    }

    return true;
  }

  private isCartPreviewVisibleTargetRoute(targetUrl: string | undefined) {
    let isCartPreviewHiddenOnTargetRoute = this.cartPreviewVisibleRoutes?.some(url => targetUrl?.includes(url));
    return isCartPreviewHiddenOnTargetRoute;
  }

  private isCartPreviewHiddenOnTargetRoute(targetUrl: string | undefined) {
    let isCartPreviewHiddenOnTargetRoute = this.cartPreviewHiddenRoutes?.some(url => targetUrl?.includes(url));
    return isCartPreviewHiddenOnTargetRoute;
  }

}
